const workerFilterHolder = {
  closeWorkerSelector(e) {
    if (workerFilterHolder.containerRef && !workerFilterHolder.containerRef.current?.contains(e.target)) {
      workerFilterHolder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", workerFilterHolder.closeWorkerSelector)
    }
  }
};

export default {
  'MultiWorkerSelector.Selector': ({ isOpen, containerRef }, _, internalStateSetter) => {
    workerFilterHolder.internalStateSetter = internalStateSetter
    workerFilterHolder.containerRef = containerRef
    internalStateSetter('isOpen', !isOpen);
    if (isOpen) {
      document.removeEventListener("mousedown", workerFilterHolder.closeWorkerSelector);
    } else {
      document.addEventListener("mousedown", workerFilterHolder.closeWorkerSelector);
    }
  },
  'MultiWorkerSelector.Body.Search': ({ value }, _, internalStateSetter) => {
    const matched = value.match(/[A-Za-z0-9\s]+/g)
    if (matched?.length > 0) {
      internalStateSetter('searchTerm', matched.shift())
    }
    else {
      internalStateSetter('searchTerm', "")
    }
  },
  'MultiWorkerSelector.Selector.LeftSide.Wrapper.SelectedButton': ({ id, selectedWorkerIds }, outlet) => {
    outlet({ selectedIds: selectedWorkerIds.filter(i => i !== id) });
  },
  'MultiWorkerSelector.Body.Workers.Worker': ({ id, selectedWorkerIds, isSingleSelect }, outlet, internalStateSetter) => {
    const newSelectedWorkerIds = [...selectedWorkerIds];
    if (newSelectedWorkerIds.includes(id)) {
      const index = newSelectedWorkerIds.indexOf(id);
      newSelectedWorkerIds.splice(index, 1)
    } else {
      newSelectedWorkerIds.push(id);
    }
    if (isSingleSelect) {
      internalStateSetter({ isOpen: false })
    }
    outlet({ selectedIds: newSelectedWorkerIds });
  },
  'MultiWorkerSelector.Body.ClearAllHeader': ({ selectedWorkerIds, workers }, outlet) => {
    if (selectedWorkerIds.length > 0) {
      outlet({ selectedIds: [] });
    } else {
      outlet({ selectedIds: workers.map(w => w.id) })
    }
  },
};
